<template>
  <div>
    <a-row :gutter="24">
      <a-col :span="6">
        <RemoteZoneLeft />
      </a-col>
      <a-col :span="12">
        <RemoteZoneMid />
      </a-col>
      <a-col :span="6">
        <RemoteZoneRight />
      </a-col>
      <RemoteZoneBottom />
    </a-row>
  </div>
</template>

<script>
import RemoteZoneRight from '@/views/remoteWater/workbench/component/RemoteZoneRight'
import RemoteZoneLeft from '@/views/remoteWater/workbench/component/RemoteZoneLeft'
import RemoteZoneMid from '@/views/remoteWater/workbench/component/RemoteZoneMid'
import RemoteZoneBottom from '@/views/remoteWater/workbench/component/RemoteZoneBottom'
import BaseMap from '@/views/sys/components/RemoteWaterMap'
export default {
  name: 'IndexVue',
  components: {
    RemoteZoneRight,
    BaseMap,
    RemoteZoneLeft,
    RemoteZoneMid,
    RemoteZoneBottom,
  },
  created () {
    this.setSystemName()
  },
  methods: {
    init () { },
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}远传表系统`)

    },
  },
}
</script>

<style scoped>
</style>
